/* Glowie UX fixes part 3 (20.10.2026) */
(function () {
  /* ---------- Product cards: move the pink dash as the photos are swiped ---------- */
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-gx-swipe]')) return;
    var dash = t.parentNode && t.parentNode.querySelector('.gx-swipe__dash');
    if (!dash || !t.clientWidth) return;
    dash.style.transform = 'translateX(' + (t.scrollLeft / t.clientWidth * 100) + '%)';
  }, true);
})();
